module.exports = __webpack_public_path__ + "static/img/1-1.356a50e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/science/1-1.png
// module id = Amuu
// module chunks = 15